import React, { useState } from "react";
import { useObjectStore } from "../zustand/objects";
import { IconWorld, IconEye } from "@tabler/icons-react";
import { Tooltip, ActionIcon } from "@mantine/core";
import { getPreviewChromeIconColour } from "../styleFile";

/**
 * @param {{ normal?: string; hover?: string }} [iconColour] — defaults from viewport theme via `getPreviewChromeIconColour`.
 */
const SwitchVRMode = ({ iconColour: iconColourProp }) => {
  const { previewVR, switchVRMode } = useObjectStore();
  const viewportThemeOverride = useObjectStore((s) => s.viewportThemeOverride);
  const [hover, setHover] = useState(false);

  const iconColour =
    iconColourProp ?? getPreviewChromeIconColour(viewportThemeOverride === "dark");
  const glyphColor = hover ? iconColour.hover : iconColour.normal;

  return previewVR ? (
    <Tooltip label="Switch to third person">
      <ActionIcon
        size="xs"
        variant="transparent"
        onPointerOver={() => setHover(true)}
        onPointerLeave={() => setHover(false)}
        onClick={() => switchVRMode()}
        style={{ color: glyphColor }}
      >
        <IconWorld size={18} />
      </ActionIcon>
    </Tooltip>
  ) : (
    <Tooltip label="Switch to first person">
      <ActionIcon
        size="xs"
        variant="transparent"
        onPointerOver={() => setHover(true)}
        onPointerLeave={() => setHover(false)}
        onClick={() => switchVRMode()}
        style={{ color: glyphColor }}
      >
        <IconEye size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default SwitchVRMode;
